<script lang="ts">
	import { afterUpdate } from 'svelte';
	import { writeTemplateString } from '../../utils/write-template-string';
	import type { TagSpec } from '../../utils/write-template-string';

	export let template: string = '';
	export let tags: TagSpec = {};

	let span: HTMLSpanElement;

	afterUpdate( () => {
		span.innerText = '';
		writeTemplateString( span, template, tags );
	} );
</script>

<span bind:this={ span }>
</span>
